<template>
  <div class="container no-margin">
    <div class="autoselect-options-container">
      <div v-if="showDropdown" class="autoselect-options">
        <div
          v-for="option in filteredOptions"
          v-bind:key="
            option.label +
              ' - ' +
              option.direccion +
              ' , ' +
              option.localidad +
              ' , ' +
              option.provincia
          "
        >
          <span
            @click="onOptionClick(option)"
            :title="
              option.label +
                ' - ' +
                option.direccion +
                ',' +
                option.localidad +
                ' , ' +
                option.provincia
            "
            >{{
              option.label +
                " - " +
                option.direccion +
                " , " +
                option.localidad +
                " , " +
                option.provincia
            }}</span
          >
        </div>
      </div>
      <img
        class="caret"
        v-if="showCaret"
        :src="caret"
        @click="toggleDropdown"
        alt="seleccion-sucursal"
      />
    </div>
    <text-input
      ref="textInput"
      class="text-input"
      hint="Sucursal"
      label="Escribí una dirección o sucursal"
      :value="selectedValue"
      :required="required"
      :subhint="subhint"
      :validationError="validationError"
      @input="onInput"
      @onFocus="onFocus"
      @onBlur="onBlur"
      @click="$emit('click')"
    />
  </div>
</template>

<script>
import TextInput from "@/components/core/TextInput";
import axios from "axios";

export default {
  name: "BranchOffices",
  components: { TextInput },
  props: [
    "placeholder",
    "label",
    "value",
    "subhint",
    "validationError",
    "items",
    "inputMode"
  ],
  data() {
    return {
      focused: false,
      internalValue: this.value,
      forceShowDropdown: false,
      caret: require("@/assets/img/1x/arrow-simple-down.svg"),
      sucursales: null
    };
  },
  created() {
    this.sucursalesfetch();
  },
  computed: {
    options: function() {
      // Parsear los items
      if (this.sucursales == null) {
        return Array();
      } else {
        return this.sucursales.data.data.map(item => {
          return {
            label: item.description ? item.description : item,
            value: item.id ? item.id : item,
            provincia: item.address.city ? item.address.city : item,
            localidad: item.address.city ? item.address.city : item,
            direccion: item.address.addressName
              ? item.address.addressName
              : item
          };
        });
      }
    },
    showDropdown() {
      return (
        this.forceShowDropdown ||
        (this.focused && this.filteredOptions.length !== this.options.length)
      );
    },
    showCaret() {
      return !this.internalValue;
    },
    filteredOptions() {
      // Obtener el value y quitar espacio
      let inputValue =
        this.internalValue && this.internalValue !== "undefined"
          ? (this.internalValue + "").trim()
          : "";
      // inputValue = this.filterLeadingZeros(inputValue);

      // Filtrar los items
      return !inputValue
        ? this.options
        : this.options.filter(item => {
            let inputIsInOption =
              inputValue &&
              (
                item.value.toLowerCase() +
                item.label.toLowerCase() +
                item.provincia.toLowerCase() +
                item.direccion.toLowerCase() +
                item.localidad.toLowerCase()
              ).indexOf(inputValue.toLowerCase()) !== -1;

            return inputValue && inputIsInOption;
          });
    },
    selectedValue() {
      if (!this.focused) {
        // Encontrar el object para el option seleccionado
        let option = this.options.find(val => {
          return val.value === this.internalValue;
        });

        // Devolver el label si lo tengo en el listado de options
        return option && option.label
          ? option.label +
              " - " +
              option.direccion +
              " , " +
              option.localidad +
              " , " +
              option.provincia
          : "";
      } else {
        // Si el input tiene foco, muestro solo su value
        return this.internalValue;
      }
    }
  },
  methods: {
    async sucursalesfetch() {
      this.sucursales = await axios.get(
        "https://servicios.bbva.com.ar/openmarket/servicios/pois/v0/branches?latitude=-34.6037345&longitude=-58.3837591&radius=5000000&branchType=INDIVIDUALS,INTEGRAL,CORPORATE"
      );
    },
    onInput(val) {
      this.internalValue = val;
    },
    onFocus() {
      this.focused = true;
    },
    onBlur() {
      setTimeout(() => {
        // Dar tiempo al select a poner el value
        this.focused = false;
        this.internalValue = this.selectedValue ? this.internalValue : "";
        this.$emit("input", this.selectedValue ? this.internalValue : "");
      }, 230);
    },
    onOptionClick(option) {
      this.$emit("input", option.value);
      this.internalValue = option.value;
      const address =
        option.label +
        " - " +
        option.direccion +
        " - " +
        option.localidad +
        " - " +
        option.provincia;
      this.$emit("address", address);
      this.forceShowDropdown = false;
    },
    toggleDropdown() {
      this.forceShowDropdown = !this.forceShowDropdown;
      if (this.forceShowDropdown) {
        this.$refs.textInput._focus();
      }
    },
    filterLeadingZeros(val) {
      // Quitar los ceros del comienzo del valor
      // TODO: Mover fuera de este componente genérico
      val = val ? val + "" : "";
      while (val.length > 0 && val.charAt(0) == 0) {
        val = val.substr(1);
      }
      return val;
    }
  }
};
</script>

<style scoped>
.autoselect-options-container {
  position: relative;
}

.autoselect-options-container .caret {
  position: absolute;
  right: 0;
  top: 0;
  /* El borde es para agrandar el area clickeable */
  border-right: 16px solid transparent;
  border-top: 18px solid transparent;
  border-bottom: 18px solid transparent;
  cursor: pointer;
  z-index: 10;
}

.autoselect-options {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  top: 56px; /* Alto inputs */
  background: white;
  max-height: 250px;
  overflow-x: hidden;
  overflow-y: auto;
  box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.2);
}

.autoselect-options span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 16px 0;
  border-bottom: 1px solid #bdbdbd;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  cursor: pointer;
}

.autoselect-options div {
  padding: 0 16px;
}
.autoselect-options div:hover {
  background-color: #eeeeee;
}

.autoselect-options div:last-child span {
  border-bottom: 0;
}

.autoselect-options span:hover {
  color: #000;
}
</style>
